var url = new URL(window.location.href)
if(url.searchParams.get("login_after_purchase")=='true') {
    console.log('ARGH')
    console.log(`${url.origin}/accounts/ellaprovider/login/?process=login`)
    document.cookie = `POC_LOCAL_REDIRECT=${url.pathname};max-age=60;path=/` // encodeURIComponent(window.location)
    location.assign(`${url.origin}/accounts/ellaprovider/login/?process=login`)
}